export interface LandingOption {
  key: string;
  label: string;
  path: string;
  external?: boolean;
}

export const DEFAULT_LANDING_KEY = 'home';

export const LANDING_OPTIONS: LandingOption[] = [
  { key: 'home', label: 'Home', path: null },
  { key: 'voice_note', label: 'Voice Note', path: 'prescription#/voice-note', external: true },
];

export function findLandingOption(key: string): LandingOption {
  if (!key || key === DEFAULT_LANDING_KEY) {
    return null;
  }
  let option = LANDING_OPTIONS.find(item => item.key === key);
  return option && option.path ? option : null;
}
